(() => {
  const searchRoutes = {
    'corvette': { query: 'tag:Corvette', label: 'Corvette signs' },
    'chevrolet': { query: 'tag:Chevy OR tag:Corvette', label: 'Chevrolet signs' },
    'chevy': { query: 'tag:Chevy OR tag:Corvette', label: 'Chevrolet signs' },
    'gm': { query: 'tag:GM OR tag:Chevy OR tag:Corvette', label: 'GM signs' },
    'general motors': { query: 'tag:GM OR tag:Chevy OR tag:Corvette', label: 'GM signs' },
    'camaro': { query: 'title:CAMARO', label: 'Camaro signs' },
    'buick': { query: 'title:BUICK', label: 'Buick signs' },
    'cadillac': { query: 'title:CADILLAC', label: 'Cadillac signs' },
    'pontiac': { query: 'title:PONTIAC', label: 'Pontiac signs' },
    'oldsmobile': { query: 'title:OLDSMOBILE', label: 'Oldsmobile signs' },
    'gmc': { query: 'title:GMC', label: 'GMC signs' },
    'mopar': { query: 'tag:Mopar/Hemi', label: 'Mopar / Hemi signs' },
    'hemi': { query: 'tag:Mopar/Hemi', label: 'Mopar / Hemi signs' },
    'mopar hemi': { query: 'tag:Mopar/Hemi', label: 'Mopar / Hemi signs' },
    'mopar/hemi': { query: 'tag:Mopar/Hemi', label: 'Mopar / Hemi signs' },
    'gas': { query: 'tag:Gas OR title:GAS', label: 'Gas and oil signs' },
    'gasoline': { query: 'tag:Gas OR title:GAS', label: 'Gas and oil signs' },
    'gas oil': { query: 'tag:Gas OR title:GAS', label: 'Gas and oil signs' },
    'gas and oil': { query: 'tag:Gas OR title:GAS', label: 'Gas and oil signs' },
    'gas & oil': { query: 'tag:Gas OR title:GAS', label: 'Gas and oil signs' },
    'pollygas': { query: 'tag:Gas OR title:GAS', label: 'Gas and oil signs' },
    'auto': { query: 'tag:Auto OR tag:Chevy OR tag:Corvette OR tag:GM OR tag:Mopar/Hemi', label: 'Automotive signs' },
    'automotive': { query: 'tag:Auto OR tag:Chevy OR tag:Corvette OR tag:GM OR tag:Mopar/Hemi', label: 'Automotive signs' },
    'automotive signs': { query: 'tag:Auto OR tag:Chevy OR tag:Corvette OR tag:GM OR tag:Mopar/Hemi', label: 'Automotive signs' },
    'aviation': { query: 'tag:Aviation', label: 'Aviation signs' },
    'diner': { query: 'tag:Diner', label: 'Diner signs' },
    'game room': { query: 'tag:Gameroom', label: 'Game room signs' },
    'gameroom': { query: 'tag:Gameroom', label: 'Game room signs' },
    'arcade': { query: 'title:ARCADE', label: 'Arcade signs' },
    'pinball': { query: 'title:PINBALL', label: 'Pinball signs' },
    'miscellaneous': { query: 'tag:Miscellaneous', label: 'Miscellaneous signs' },
    'misc': { query: 'tag:Miscellaneous', label: 'Miscellaneous signs' },
    'custom': { query: 'tag:Custom', label: 'Custom signs' },
    'soda': { query: 'tag:Soda', label: 'Soda machines' },
    'soda machine': { query: 'tag:Soda', label: 'Soda machines' },
    'soda machines': { query: 'tag:Soda', label: 'Soda machines' },
    'vending machine': { query: 'tag:Soda', label: 'Soda machines' },
    'vending machines': { query: 'tag:Soda', label: 'Soda machines' },
    'coca cola': { query: 'tag:Soda', label: 'Soda machines' },
    'coca-cola': { query: 'tag:Soda', label: 'Soda machines' },
    'coke': { query: 'tag:Soda', label: 'Soda machines' },
  };
  const normalizeTerm = (value) => value.trim().toLowerCase().replace(/\s+/g, ' ').replace(/^(?:neon\s+)?/, '').replace(/\s+(?:neon\s+)?(?:clock\s+)?signs?$/, '').replace(/\s+neon$/, '').trim();
  const routeForTerm = (value) => searchRoutes[normalizeTerm(value)] || null;

  const ensureHiddenField = (form, name, value) => {
    let field = form.querySelector(`input[name="${name}"]`);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[role="search"]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    ensureHiddenField(form, 'type', 'product');
    ensureHiddenField(form, 'options[prefix]', 'none');
    const route = routeForTerm(input.value);
    if (!route) return;

    event.preventDefault();
    input.value = route.query;
    HTMLFormElement.prototype.submit.call(form);
  }, true);
})();
